import Images from "../../assets/images"; 

export default Images;
